var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-edit-wrapper",
    { attrs: { "no-scroll": "", company: _vm.value } },
    [
      _c(
        "w-button-bar",
        { attrs: { slot: "actions" }, slot: "actions" },
        [
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.addDisabled },
              on: {
                click: function ($event) {
                  return _vm.addClicked()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "plus" } })],
            1
          ),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.editDisabled },
              on: {
                click: function ($event) {
                  return _vm.editClicked()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "pen" } })],
            1
          ),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.deleteDisabled },
              on: {
                click: function ($event) {
                  return _vm.removeClicked()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "minus" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: { "flex-grow": "1" },
                attrs: {
                  columns: _vm.columns,
                  items: _vm.value.dossiers,
                  "selected-items": _vm.selectedRows,
                },
                on: {
                  "item-clicked": function ($event) {
                    return _vm.editDossier($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.newDossierModal } },
        [
          _c("app-dossier-new", {
            attrs: { value: _vm.newDossier, company: _vm.value },
            on: {
              input: function ($event) {
                return _vm.editDossier($event)
              },
              close: function ($event) {
                _vm.newDossierModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }